import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import Tooltip from '@material-ui/core/Tooltip';

const styles = {
  tooltip: {
    width: '15px',
    height: '15px'
  }
};

class HpTooltip extends Component {
  render() {
    const { classes, message, styling } = this.props;

    return (
      <React.Fragment>
        <Tooltip
          className={classes.tooltip}
          style={styling}
          title={message}
          placement="right"
        >
          <HelpOutlineIcon />
        </Tooltip>
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(HpTooltip);



// WEBPACK FOOTER //
// ./src/components/shared/components/hpTooltip.js